import React, { Component } from 'react'
import { connect } from 'react-redux'
import './App.css'
import { Footer } from './components/ImportAll'
import { step, notExistView } from './engine/StepDefinition'
import BannerEnvIndicator from './components/BannerEnvIndicator/BannerEnvIndicator'
import { InitDossier, InitHistoryListener } from './engine/Rules'
import { InitWlcReferralWidget } from './engine/WlcReferralWidget'

class App extends Component {
    render() {
        // if first render, set value on redux to indicate initialization already executed.
        if (!this.props.answer.tech_already_initialized) {
            console.log('Initialisation du widget parrainage WLC')
            InitWlcReferralWidget()
            InitHistoryListener()
            InitDossier()
        }

        // get, and show the right view from redux variable.
        let state = this.props.view
        let targetview = notExistView.content
        if (state >= 0 && state <= step.length - 1) {
            targetview = step[state].content
            // retourner en haut de page au changement de view
            window.scrollTo(0, 0)
        }

        return (
            <div className="App">
                <BannerEnvIndicator />
                {targetview}
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        view: state.view,
        answer: state.answer,
    }
}

export default connect(mapStateToProps)(App)
